<template>
	<section class="small-12 columns flex justify-center featuredArticle animated fadeIn">
        <div class="small-12 flex justify-center columns image">
            <picture>
                <img class="animated fadeIn" width="360" :src="image" alt="Article Feature Image">
            </picture>
        </div><div class="small-12 columns flex justify-center title">
            <h2>Article or Post Title Goes Here</h2>
            <p class="text-center">
                Black Lives Matter. Ongoing action to fight systemic racism, led by 
                our employees, championed by our leadership, will be a fundamental 
                part of our operations—for the long haul.
            </p>
        </div>
    </section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'LatestArticle',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/articles%2Fpiggy-bank.jpg?alt=media&token=269f406b-1884-4ba4-bdd6-77d484815066'

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>